<!-- 扫码机上报绑定通道信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportQrCode",
                "parkCode": "",
                "scanMachineId": "",
                "userCode": "",
                "sensorStatus": 1,
                "time": "",
                "lockKey": "2420e3efbf6124c7185365b79c75c0f5be61a049"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报扫码机绑定通道信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportChannelBindForScan",
                precondition: "无",
                fitSystem: "VEMS传统停车场,云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'scanMachineId', info2: '是', info3: 'String', info4: '扫码机全球唯一ID' },
                        { info1: 'parkType', info2: '是', info3: 'Integer', info4: '车场系统类型(0 VEMS停车场，1云停车场)' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'channelId', info2: '是', info3: 'String', info4: '通道编码（vems为自定义编码）' },
                        { info1: 'channelName', info2: '是', info3: 'String', info4: '通道名称' },
                        { info1: 'time', info2: '是', info3: 'String', info4: '发生时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/device/scan/reportChannelBindForScan.vue